import { render } from "./GYLFW.vue?vue&type=template&id=e77bdae8"
import script from "./GYLFW.vue?vue&type=script&lang=js"
export * from "./GYLFW.vue?vue&type=script&lang=js"

import "./GYLFW.vue?vue&type=style&index=0&id=e77bdae8&lang=scss"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__